import { media, styled, css } from '@nx-kit/styling';
import Icon from 'components/atoms/Icon/Icon';

import { CourseStatusColors } from 'pages/api/courseApi.types';

export const GridItemWrapper = styled.div`
  position: relative;
  flex: 1 1 auto;

  ${media('sm')} {
    flex: 1 1 50%;
    max-width: calc(50% - 16px);
  }

  ${media('xl')} {
    flex: 1 1 30%;
    max-width: calc(33% - 32px);
  }
`;

export const StatusStyled = styled.div<{ color: string }>`
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: ${({ theme }) => theme.global.zIndex.statusCourseBox};
  background: ${({ theme }) => theme.global.color.white};
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 4px 10px;
  gap: 10px;

  ${({ color }) => {
    if (color === CourseStatusColors.green) {
      return css`
        display: none;
      `;
    }
  }}
`;

export const StatusLabelStyled = styled.div`
  font-size: 13px;
  line-height: 20px;
`;

export const ImageStyled = styled.div`
  min-height: 184px;
  height: 184px;
`;

export const ContextBoxStyled = styled.div`
  padding: 20px 30px 30px;
`;

export const TitleStyled = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 19px;
`;

export const SlotsStyled = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.global.color.gray500};
  padding-bottom: 17px;
  margin-bottom: 17px;
  display: flex;
  flex-direction: column;
`;

export const SlotTextStyled = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
`;

export const PriceBoxStyled = styled.div`
  display: flex;
`;

export const SlotPriceStyled = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  min-width: 44%;
`;

export const SlotInfoStyled = styled.div`
  font-size: 13px;
  line-height: 20px;
  text-align: right;
  color: ${({ theme }) => theme.global.color.gray180};
`;

export const InfoRowStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWrapperStyled = styled.div`
  width: 24px;
  min-width: 24px;
  text-align: left;
  margin-right: 5px;
`;

export const IconStyled = styled(Icon)`
  color: ${(props) => props.theme.global.color.primary};
  width: 24px;
  height: 24px;
  margin-right: 4px;
  margin-top: 2px;
`;
